import { Observable } from 'rxjs';
import { SchedulerItemOnMachineCRUD } from '../../../api/backend/dto/scheduler-item-on-machine.dto';
import { SchedulerItemOnMachine } from '../models/item-on-machine';

type AddBody = SchedulerItemOnMachineCRUD['add'];
type UpdateBody = SchedulerItemOnMachineCRUD['update'];
type StopBody = SchedulerItemOnMachineCRUD['stop'];

export abstract class SchedulerItemOnMachineApiAbstract {
  abstract addItem(body: AddBody): Observable<SchedulerItemOnMachine>;

  /**
   * Update the place where the machine is
   * @param body thins to modify
   * @description
   * this function will hell to tell to what machine a item is being moved.
   */
  abstract updateItem(body: UpdateBody): Observable<SchedulerItemOnMachine>;

  /**
   * Remove the item from the machine
   * @param itemId the id of the batch, subWorkOrder or the transactionId
   * @param machineId the id of the machine
   * @description
   * This functions is meant to be used when you try to remove a work order from a machine
   * this does not mean that the work order will move to another machine, it actually means
   * that the record will be deleted. This function will be of great help when trying to
   * put the work order again on the waiting list, or when you don't want to see the work order on the machine.
   */
  abstract removeItem(itemId: number, machineId: number): Observable<any>;

  abstract startItemOnMachine(
    itemId: number,
    machineId: number,
    options?: { [key: string]: any }
  ): Observable<any>;

  abstract stopItemOnMachine(body: StopBody): Observable<any>;

  abstract removeRunning(machineId: number, itemId: number): Observable<any>;
}
